import React, {Component} from 'react';
import {connect} from 'react-redux';
import OpcoesPaginacao from '../../comum/OpcoesPaginacao';
import alterarRegistrosPorPagina from '../../../actions/itinerario/alterarRegistrosPorPaginaRelatorioItinerarios';
import determinarPaginaAtual from '../../../actions/itinerario/determinarPaginaAtualRelatorioItinerarios';

export class OpcoesPaginacaoRelatorioItinerarios extends Component {
    render() {
        if (this.props.itinerarios.length === 0) {
            return '';
        }

        return <OpcoesPaginacao
            registrosPorPagina={this.props.registrosPorPagina}
            numeroElementos={this.props.itinerarios.length}
            paginaAtual={this.props.paginaAtual}
            determinarPaginaAtual={this.props.determinarPaginaAtual}
            alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>;
    }
}

export function mapStateToProps(state) {    
    return {
        itinerarios: state.relatorioItinerarios,
        paginaAtual: state.paginaAtualRelatorioItinerarios,
        registrosPorPagina: state.registrosPorPaginaRelatorioItinerarios
    };
}

export default connect(mapStateToProps, {
    alterarRegistrosPorPagina,
    determinarPaginaAtual
})(OpcoesPaginacaoRelatorioItinerarios);
